import WpSale, { WpSaleSteps } from './../../components/WpSale/wp-sale';
import Component from 'vue-class-component';
import { ErrorTypes, OrderItemType, IsdUserLoyalty, ILoyaltyProvider, LoyaltySymbols } from 'web-platform-core-ui';

@Component
export default class VdnhKatokSale extends WpSale {
    public async ReservateCartAsync() {
        if (!this._context.CurrentIdentity.IsAuthentificated) {
            this._redirectToAuth = true;
            this._context.SignIn();
            return;
        }

        let personId: number | null | undefined;
        let loyaltyProvider = this.GlobalService.Get<ILoyaltyProvider>(LoyaltySymbols.LoyaltyProvider);
        let userLoyalty = await loyaltyProvider.GetIsdUserLoyaltyAsync();

        if (userLoyalty.Success) {
            let loyaltyList = await this._saleService.GetLoyaltyListAsync();

            if (loyaltyList.Success && loyaltyList.Data != null && loyaltyList.Data.length > 0 &&
                (this.Settings.LoyaltyId == null || this.Settings.LoyaltyId == 0)) {
                this.Settings.LoyaltyId = loyaltyList.Data[0].Id;
            }

            if (userLoyalty.Data == null) {
                this.LoyaltyDialog = true;
                return;
            } else {
                personId = userLoyalty.Data.PersId;
            }
        } else {
            this._notificationService.Error('', userLoyalty?.ErrorMessage ?? this.Terms.InternalError);
            return;
        }

        this.HasPersonification = false;
        this.NextLoading = true;
        this.LoadingOverlay = true;
        let reservationResult = await this._saleService.ReservateAsync(this.Cart, personId);

        if (!reservationResult.Success || reservationResult.Data == null) {
            if (reservationResult.ErrorType == ErrorTypes.QuotaExceededForTariff) {
                this._notificationService.Error("", this.Terms.CartItemCountError);
            }
            else if (reservationResult.ErrorType == ErrorTypes.TariffNotAvailableForSale) {
                this._notificationService.Error("", this.Terms.CartItemNotAvailableError);
            } else if (reservationResult.ErrorType == ErrorTypes.CardWithSoTypeTariff) {
                this._notificationService.Error("", this.Terms.CardHaveTariffWithSoType);
            } else if (reservationResult.ErrorType == ErrorTypes.LessonNotAvailable) {
                this._notificationService.Error("", this.Terms.LessonNotAvailable);
            } else if (reservationResult.ErrorType == ErrorTypes.RewriteTariffNotAvailable) {
                this._notificationService.Error("", this.Terms.CardHaveNotUsedTariff);
            } else {
                this._notificationService.Error("", reservationResult.ErrorMessage ? reservationResult.ErrorMessage : this.Terms.InternalError);
            }

            this.ShowSteps = false;

            this.$nextTick(() => {
                this.$emit('LoadingFinished');
                this.NextLoading = false;
                this.ShowSteps = true;
                this.LoadingOverlay = false;
            });

            return;
        }
        if (reservationResult.Data.Items.some(x => (x.Type == OrderItemType.TariffPersonification ||
            x.Type == OrderItemType.TariffBarcodePesonification ||
            x.Type == OrderItemType.TariffRewritablePesonification)
            && x.AdditionalInfo != undefined && x.AdditionalInfo.Info != undefined &&
            x.AdditionalInfo.Info != null && x.AdditionalInfo.Info.includes('_unknow'))) {
            this.HasPersonification = true;
        }

        this.Cart.Reset();
        this.NextLoading = false;

        this.OrderId = reservationResult.Data.Id;
        parent.postMessage({ status: 'reserved', data: { order_id: this.OrderId, order: reservationResult.Data } }, '*');
        if (this.HasPersonification) {
            this.Step = WpSaleSteps.Personification;
        }
        else {
            this.Step = WpSaleSteps.PayConfirm;
        }
        this.$emit('LoadingFinished');
        this.LoadingOverlay = false;
    }
}